import React, { useState, useEffect } from 'react';
import {
  Box,
  Paper,
  Typography,
  Grid,
  Card,
  CardContent,
  CardHeader,
  Button,
  Chip,
  LinearProgress,
  Alert,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@mui/material';
import {
  IntegrationInstructions as IntegrationIcon,
  CheckCircle as CheckCircleIcon,
  Error as ErrorIcon,
  Sync as SyncIcon,
  Settings as SettingsIcon,
} from '@mui/icons-material';

const SapIntegration: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setLoading(true);
    setTimeout(() => setLoading(false), 1000);
  }, []);

  const integrations = [
    { id: '1', name: 'SAP ERP', status: 'connected', lastSync: '2024-01-15 10:30:00' },
    { id: '2', name: 'SAP BW', status: 'connected', lastSync: '2024-01-15 09:45:00' },
    { id: '3', name: 'SAP CRM', status: 'disconnected', lastSync: '2024-01-14 16:20:00' },
    { id: '4', name: 'SAP SCM', status: 'error', lastSync: '2024-01-15 08:15:00' },
  ];

  return (
    <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom sx={{ fontWeight: 'bold', color: 'primary.main' }}>
          SAP Integration
        </Typography>
        <Typography variant="body1" color="text.secondary">
          SAP system integration management
        </Typography>
      </Box>

      {loading && <LinearProgress sx={{ mb: 2 }} />}
      
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Active Integrations
            </Typography>
            <List>
              {integrations.map((integration) => (
                <ListItem key={integration.id} divider>
                  <ListItemIcon>
                    {integration.status === 'connected' ? (
                      <CheckCircleIcon color="success" />
                    ) : integration.status === 'error' ? (
                      <ErrorIcon color="error" />
                    ) : (
                      <ErrorIcon color="disabled" />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    primary={integration.name}
                    secondary={`Last sync: ${integration.lastSync}`}
                  />
                  <Chip
                    label={integration.status}
                    color={
                      integration.status === 'connected' ? 'success' :
                      integration.status === 'error' ? 'error' : 'default'
                    }
                    size="small"
                  />
                </ListItem>
              ))}
            </List>
          </Paper>
        </Grid>
        
        <Grid item xs={12} md={4}>
          <Paper sx={{ p: 2 }}>
            <Typography variant="h6" gutterBottom>
              Quick Actions
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Button variant="contained" startIcon={<SyncIcon />}>
                Sync All
              </Button>
              <Button variant="outlined" startIcon={<SettingsIcon />}>
                Configure
              </Button>
              <Button variant="outlined" color="error">
                Disconnect All
              </Button>
            </Box>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SapIntegration; 